import React from 'react';

export const AnimatedBackground: React.FC = () => {
  return (
    <div className="absolute inset-0 overflow-hidden" style={{ zIndex: -10 }}>
      <svg
        className="absolute bottom-0 left-0 w-full h-full max-h-[600px] md:max-h-none"
        viewBox="0 0 1000 600"
        preserveAspectRatio="xMidYMax meet"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient id="waterGradient1" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#CFF710" stopOpacity="0.15" />
            <stop offset="50%" stopColor="#80D033" stopOpacity="0.12" />
            <stop offset="100%" stopColor="#00D084" stopOpacity="0.10" />
          </linearGradient>
          <linearGradient id="waterGradient2" x1="100%" y1="0%" x2="0%" y2="100%">
            <stop offset="0%" stopColor="#00D084" stopOpacity="0.12" />
            <stop offset="50%" stopColor="#80D033" stopOpacity="0.10" />
            <stop offset="100%" stopColor="#CFF710" stopOpacity="0.15" />
          </linearGradient>
          <filter id="blur1">
            <feGaussianBlur stdDeviation="15" />
          </filter>
          <filter id="blur2">
            <feGaussianBlur stdDeviation="20" />
          </filter>
          <filter id="blur3">
            <feGaussianBlur stdDeviation="25" />
          </filter>
        </defs>
        
        {/* First smoke puff */}
        <ellipse
          cx="50"
          cy="450"
          rx="80"
          ry="60"
          fill="url(#waterGradient1)"
          filter="url(#blur1)"
          style={{
            animation: 'smoke-drift-1 12s ease-out infinite',
            transformOrigin: 'center'
          }}
        />
        
        {/* Second smoke puff */}
        <ellipse
          cx="120"
          cy="480"
          rx="100"
          ry="75"
          fill="url(#waterGradient2)"
          filter="url(#blur2)"
          style={{
            animation: 'smoke-drift-2 15s ease-out infinite 2s',
            transformOrigin: 'center'
          }}
        />
        
        {/* Third smoke puff */}
        <ellipse
          cx="80"
          cy="420"
          rx="60"
          ry="90"
          fill="url(#waterGradient1)"
          filter="url(#blur3)"
          style={{
            animation: 'smoke-drift-3 18s ease-out infinite 4s',
            transformOrigin: 'center'
          }}
        />
        
        {/* Fourth smoke puff */}
        <ellipse
          cx="40"
          cy="500"
          rx="90"
          ry="70"
          fill="url(#waterGradient2)"
          filter="url(#blur1)"
          style={{
            animation: 'smoke-drift-4 14s ease-out infinite 6s',
            transformOrigin: 'center'
          }}
        />
        
        {/* Additional smoke elements */}
        <ellipse
          cx="160"
          cy="460"
          rx="50"
          ry="40"
          fill="url(#waterGradient1)"
          filter="url(#blur2)"
          style={{
            animation: 'smoke-drift-1 10s ease-out infinite 8s',
            transformOrigin: 'center'
          }}
        />
        
        <ellipse
          cx="20"
          cy="520"
          rx="70"
          ry="55"
          fill="url(#waterGradient2)"
          filter="url(#blur3)"
          style={{
            animation: 'smoke-drift-2 16s ease-out infinite 10s',
            transformOrigin: 'center'
          }}
        />
        
        {/* More smoke for continuous effect */}
        <ellipse
          cx="110"
          cy="510"
          rx="40"
          ry="65"
          fill="url(#waterGradient1)"
          filter="url(#blur2)"
          style={{
            animation: 'smoke-drift-3 13s ease-out infinite 12s',
            transformOrigin: 'center'
          }}
        />
        
        <ellipse
          cx="70"
          cy="440"
          rx="85"
          ry="50"
          fill="url(#waterGradient2)"
          filter="url(#blur1)"
          style={{
            animation: 'smoke-drift-4 17s ease-out infinite 14s',
            transformOrigin: 'center'
          }}
        />
      </svg>
    </div>
  );
}; 